// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"u2-z","dimensionLabel":"v2-z","styleChooserControlWrapper":"w2-z","styleChooserControl":"x2-z","disabled":"y2-z","giftCard":"z2-z","styleChooserText":"A2-z"};